import { AppBar, Box, Button, IconButton, InputAdornment, OutlinedInput, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Await, useNavigate } from 'react-router-dom';
import thaiD from '../../assets/icons/thaiD.svg'
import imgLogin from '../../assets/icons/login.svg'
import logo from '../../assets/icons/logo.svg'
import styles from './login.module.css'
import Loader from '../../components/Loader';
import * as api from '../services/api'
import { useDispatch } from 'react-redux';
import { login as login_reduce, user_data } from '../../store/authSlice';
import Footer from 'components/Footer';
import { useSelector } from 'react-redux';

function SignIn() {
    const dispatch = useDispatch()
    const version = useSelector(state => state.vers.value)
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [locked, setLocked] = useState(false)

    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };

    const toComponentAuth = async (path, state) => {
        navigate(path, {
            state: state
        })
    }

    // ตรวจสอบสถานะ lock ตอนเปิดหน้า
    useEffect(() => {
        if (username) checkLockStatus(username)
    }, [username])

    const getLoginData = () => {
        return JSON.parse(localStorage.getItem('login_data') || '{}')
    }

    const saveLoginData = (data) => {
        localStorage.setItem('login_data', JSON.stringify(data))
    }

    const checkLockStatus = (user) => {
        const data = getLoginData()
        const userData = data[user]
        if (!userData) return setLocked(false)

        const now = Date.now()
        const diff = now - userData.timestamp
        const limit = 24 * 60 * 60 * 1000 // 24 ชั่วโมง

        if (userData.attempts >= 3 && diff < limit) {
            setLocked(true)
        } else if (diff >= limit) {
            // ครบเวลา reset
            delete data[user]
            saveLoginData(data)
            setLocked(false)
        } else {
            setLocked(false)
        }
    }

    const handleFailedLogin = (user) => {
        const data = getLoginData()
        const userData = data[user] || { attempts: 0, timestamp: 0 }
        const attempts = userData.attempts + 1

        data[user] = { attempts, timestamp: Date.now() }
        saveLoginData(data)

        if (attempts >= 3) {
            setLocked(true)
            alert(`บัญชี "${user}" ถูกล็อก 24 ชั่วโมง`)
        }
    }

    const resetLoginLimit = (user) => {
        const data = getLoginData()
        if (data[user]) {
            delete data[user]
            saveLoginData(data)
        }
        setLocked(false)
    }

    const clickLogin = () => {
        if (!username) return alert('กรอกชื่อผู้ใช้')
        if (!password) return alert('กรอกรหัสผ่าน')

        if (locked) return alert(`บัญชี "${username}" ถูกล็อก กรุณาลองใหม่ใน 24 ชั่วโมง`)

        login()
    }

    const loginByThaiD = () => {
        GenerateURLThaiD()
    }

    const login = async () => {
        setLoading(true)
        let res = await api.login(username, password)
        setLoading(false)

        if (!res) return alert('ไม่ตอบสนอง')

        const code = res['code']
        const mess = res['message']

        if (code === 200) {
            dispatch(login_reduce(res['data']))
            localStorage.setItem('AccessToken', res['data']['access_token'])
            localStorage.setItem('RefreshToken', res['data']['refresh_token'])

            resetLoginLimit(username) // ล้างการล็อกเมื่อ login สำเร็จ
            toComponentAuth('/profile')
        } else if (code === 204 || code === 401 || code === 400) {
            alert('ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง หากท่านกรอกข้อมูลผิดครบ 3 ครั้ง บัญชีจะถูกล๊อคการใช้งาน 24 ชั่วโมง')
            handleFailedLogin(username) // เพิ่มจำนวนครั้งผิด
        } else if (code === 403) {
            if (mess == 'บัญชีผู้ใช้ถูกระงับการใช้งานชั่วคราว') {
                alert('บัญชีของคุณถูกปิดใช้งานชั่วคราว เนื่องจากเข้าสู่ระบบล้มเหลวหลายครั้ง กรุณาเข้าใช้งานใหม่อีกครั้งในวันถัดไป')
            } else if (mess == 'บัญชีผู้ใช้ไม่สามารถใช้งานได้ กรุณาติดต่อเจ้าหน้าที่') {
                alert('บัญชีของคุณยังไม่ถูกเปิดใช้งาน กรุณาติดต่อแอดมินเพื่อเปิดใช้งานระบบ')
            }
        } else {
            console.log('error', res)
        }

        // if (res) {
        //     if (res['data']['code'] === 200) {
        //         dispatch(login_reduce(res['data']['data']))

        //         localStorage.setItem('AccessToken', res['data']['data']['access_token'])
        //         localStorage.setItem('RefreshToken', res['data']['data']['refresh_token'])

        //         toComponentAuth('/profile')
        //     } else if (res['data']['code'] === 204 || res['data']['code'] === 401) {
        //         alert('ชื่อผู้ใช้หรือรหัสผ่านไม่ถูกต้อง')
        //     } else {
        //         console.log(res['data']['message'])
        //     }
        // } else {
        //     alert('ไม่ตอบสนอง')
        // }
    }

    const GenerateURLThaiD = async () => {
        setLoading(true)
        let res = await api.GenerateURLThaiD({ origin: window.location.origin })
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                console.log(res['data']['url'])
                window.open(res['data']['url'], '_blank')
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    return (
        <>
            <Loader loading={loading} />
            <AppBar
                position="sticky"
                sx={{
                    backgroundColor: '#FFFFFF',
                    padding: '10px',
                    color: '#000000',
                    "@media (max-width: 800px)": {
                        fontSize: '12px'
                    },
                }}
            >
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between'
                }}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gridGap: '10px'
                    }}>
                        <img className={styles.logo} src={logo} />
                        <Box>
                            <div>ระบบข้อมูลสุขภาพกำลังพล สป.</div>
                            <div style={{ fontSize: '12px' }}>เวอร์ชัน {version || '-'}</div>
                        </Box>
                    </Box>
                    <Box>
                        <Button
                            variant='contaimed'
                            sx={{
                                backgroundColor: '#D1E6FF',
                                "@media (max-width: 500px)": {
                                    fontSize: '10px',
                                    padding: '5px'
                                },
                            }}
                            onClick={() => { navigate('/login') }}
                        >เข้าสู่ระบบ</Button>
                    </Box>
                </Box>
            </AppBar>

            <Box sx={design.container} >
                <Box sx={design.mainSection}>
                    <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr',
                        gridGap: '20px',
                        padding: '50px',
                        "@media (max-width: 800px)": {
                            padding: '0',
                            gridTemplateColumns: '1fr'
                        },
                    }}>
                        <Box sx={{
                            display: 'grid',
                            justifyItems: 'center'
                        }}>
                            <img className={styles.imgLogin} src={imgLogin} />
                        </Box>

                        <Box sx={{
                            display: 'grid',
                            alignContent: 'center',
                            justifyItems: 'center'
                        }}>
                            <Box sx={{
                                display: 'grid',
                                gridGap: '20px',
                                width: '500px',
                                "@media (max-width: 1200px)": {
                                    width: '400px'
                                },
                                "@media (max-width: 800px)": {
                                    width: '100%'
                                },
                            }}>
                                <Typography sx={{
                                    textAlign: 'center',
                                    fontWeight: 600,
                                    fontSize: '20px',

                                }}>เข้าสู่ระบบ</Typography>
                                <TextField
                                    type='number'
                                    onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                    InputProps={{
                                        sx: {
                                            '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                                                display: 'none'
                                            },
                                            '& input[type=number]': {
                                                MozAppearance: 'textfield'
                                            },
                                        }
                                    }}
                                    placeholder='เลขบัตรประชาชน'
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    value={username}
                                    onChange={(e) => {
                                        setUsername(!e.target.value ? null : Number(String(e.target.value).slice(0, 13)))
                                    }}
                                />
                                <OutlinedInput
                                    id="outlined-adornment-password"
                                    type={showPassword ? "text" : "password"}
                                    placeholder='รหัสผ่าน'
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    value={password}
                                    onChange={(e) => { setPassword(e.target.value) }}
                                    onKeyDown={(ev) => {
                                        if (ev.key === 'Enter') {
                                            clickLogin()
                                        }
                                    }}
                                    endAdornment={
                                        <InputAdornment position="end" >
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={handleClickShowPassword}
                                                onMouseDown={handleMouseDownPassword}
                                                onMouseUp={handleMouseUpPassword}
                                                edge="end"
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />

                                <Box sx={{
                                    color: '#0098EA',
                                    cursor: 'pointer',
                                    alignItems: "flex-end",
                                    justifyItems: 'flex-end',
                                    textAlign: 'end'
                                }}
                                    onClick={() => { navigate('/forgetPassword') }}
                                >รีเซ็ทรหัสผ่าน ?</Box>

                                {/* <Typography sx={{ color: '#0098EA', textAlign: 'end' }}>ลืมรหัสผ่าน ?</Typography> */}

                                {/* <Button
                                    variant="contained"
                                    onClick={() => { clickLogin() }}
                                >เข้าสู่ระบบ</Button> */}

                                <Button
                                    variant="contained"
                                    onClick={clickLogin}
                                    disabled={loading || locked}
                                >
                                    {locked ? 'บัญชีถูกล็อก 24 ชม.' : loading ? 'กำลังเข้าสู่ระบบ...' : 'เข้าสู่ระบบ'}
                                </Button>

                                <Box sx={{
                                    display: 'flex',
                                    gridGap: '10px',
                                    fontWeight: 600
                                }}>
                                    <Box>ยังไม่มีบัญชี?</Box>
                                    <Box sx={{
                                        color: '#0098EA',
                                        cursor: 'pointer'
                                    }}
                                        onClick={() => { navigate('/register') }}
                                    >กดเพื่อลงทะเบียน</Box>
                                </Box>

                                <Box sx={{
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 2fr 1fr',
                                    justifyItems: 'center',
                                    alignItems: 'center',
                                    color: '#D0D0D0'
                                }}>
                                    <Box sx={{ border: '1px solid #D0D0D0', width: '100%' }}></Box>
                                    <Box>หรือเข้าใช้งานด้วย</Box>
                                    <Box sx={{ border: '1px solid #D0D0D0', width: '100%' }}></Box>
                                </Box>

                                <Button
                                    sx={{ display: 'flex', gridGap: '10px' }}
                                    variant='outlined'
                                    onClick={() => { loginByThaiD() }}
                                // onClick={() => { alert('ยังไม่เปิดให้บริการ') }}
                                >
                                    <img src={thaiD} style={{ width: '35px' }} />
                                    <div>ThaiD</div>
                                </Button>

                            </Box>
                        </Box>

                    </Box>
                </Box>
            </Box>

            <Footer />
        </>
    )
}

const design = {
    container: {
        display: "flex",
        bgcolor: "neutral.light",
    },
    mainSection: {
        px: { xl: 4, lg: 4, md: 4, sm: 2, xs: 2 },
        py: { xl: 4, lg: 4, md: 4, sm: 2, xs: 2 },
        width: "100%",
        overflow: "auto",
    },
};

export default SignIn
